export const EQ = "eq"; //equal to
export const GT = "gt"; //greater than
export const LT = "lt"; //less than
export const NE = "ne"; //not equal
export const GTE = "gte"; //greater than or equal
export const LTE = "lte"; //less than or equal
export const SIMILARTO = "similar_to"; //used maily for multi-select inputs, values are pipe seperated
export const BETWEEN = "between"; //between
export const LIKE = "like"; //contains
export const DATE = "date"; //fieldType = date
export const BOOL = "boolean"; //fieldType = boolean
export const STRING = "string"; //fieldType = string
export const NUMBER = "number"; //fieldType = mumeric value
export const ARRAY = "string_array"; //fieldType =  “string_array”, values =  pipe seperated values eg. “string1"|“string2”|“string3"
export const defaultReportColumnDefs = {
  resizable: true,
  sortable: true,
  floatingFilter: true,
  filter: "agTextColumnFilter",
  filterParams: { buttons: ["reset", "cancel"], closeOnApply: true },
  suppressAndOrCondition: true,
  suppressMenuHide: false,
  cellStyle: (params) => {
    return {
      color: "black",
      fontSize: 14,
      fontWeight: 400,
      padding: 8,
      borderRight: "1px solid #a0a0a0",
    };
  },
  suppressKeyboardEvent: (params) => true,
};
